var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',[_c('hr'),_c('strong',[_vm._v("IQMAS EXE ©")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }